import Vue from 'vue'
import * as VueGoogleMaps from 'gmap-vue'
import GmapCluster from 'gmap-vue/dist/components/cluster'

const GMAP_API_KEY = process.env.GMAP_API_KEY

// console.log('GMAP_API_KEY: ', GMAP_API_KEY)

Vue.use(VueGoogleMaps, {
	load: {
		key: GMAP_API_KEY,
		libraries: 'places,drawing,visualization',
		region: 'ID',
		language: 'id'
	},
	installComponents: true
})

Vue.component('GmapCluster', GmapCluster)



// WEBPACK FOOTER //
// ./src/libs/google-map.js